<button mat-raised-button *appRole="['TiposBonificacion.Crear']" color="primary" [routerLink]="['/tiposbonificacion']">
  <mat-icon>add</mat-icon>
  Nuevo tipo bonificación
</button>
